package org.catharsis.spendtel.core.impl

import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.firestore.FirebaseFirestore
import io.github.aakira.napier.Napier
import org.catharsis.spendtel.feature.data.SpendtelUser
import org.catharsis.spendtel.feature.data.toFirestoreMap

internal suspend fun persistSpendtelUserProfile(
    firestore: FirebaseFirestore,
    auth: FirebaseAuth,
    user: SpendtelUser,
): Result<Unit> {
    return try {
        val firebaseUser = auth.currentUser
            ?: return Result.failure(IllegalStateException("You must be signed in to save your profile."))

        if (firebaseUser.uid != user.uid) {
            return Result.failure(IllegalStateException("Signed-in user does not match profile owner."))
        }

        // Ensure Firestore requests include a fresh auth token on web.
        firebaseUser.getIdToken(forceRefresh = true)

        val document = firestore.collection("USERS").document(user.uid)
        document.set(user.toFirestoreMap())

        if (document.get().exists) {
            Result.success(Unit)
        } else {
            Result.failure(IllegalStateException("Firestore profile document was not created."))
        }
    } catch (e: Exception) {
        Napier.e("Firestore profile sync failed for ${user.uid}: $e")
        Result.failure(e)
    }
}
